import { createFileRoute } from "@tanstack/react-router";
import { B2bChannelsPanel } from "@/components/b2b/B2bChannelsPanel";
import { ProduccionB2bShell } from "@/components/b2b/ProduccionB2bShell";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";

export const Route = createFileRoute("/app/produccion/canales")({
  component: ProduccionCanalesPage,
  head: () => ({ meta: [{ title: "Canales — B2B / Mayorista" }] }),
});

function ProduccionCanalesPage() {
  const tid = useWorkspaceTenantId();
  return (
    <ProduccionB2bShell title="Canales B2B">
      {tid ? <B2bChannelsPanel tenantId={tid} /> : null}
    </ProduccionB2bShell>
  );
}
